import reportException from '../report-exception';
// exit callbacks is an array of functions that must return true if
// the loop should be exited and false otherwise
// order of the exit callback array matters!
export default async function pollForNewState(args) {
  const {
    initialPromise, killTimer, exitCallbacks, interval, setTimerRef, displayName,
  } = args;

  try {
    const action = await initialPromise();

    if (!action || !action.result || !action.result.data) {
      killTimer();
      reportException(action, displayName);
      return action || {};
    }

    const { result } = action;
    const { data } = result;
    const shouldExitWithoutFurtherPolling = exitCallbacks.some(callback => callback(data));

    if (shouldExitWithoutFurtherPolling) {
      killTimer();
      return action;
    }

    const newTimer = () => setTimeout(() => pollForNewState(args), interval);

    setTimerRef(newTimer);

    return action;
  } catch (error) {
    killTimer();

    console.log('error', error);

    reportException(error, displayName);

    return error;
  }
}



// WEBPACK FOOTER //
// ./shared/lib/poll-for-new-state/index.js